import { Controller } from "@hotwired/stimulus"

// The membership flow's email step (TMS-1654). Continue is enabled only while the email looks
// valid. Once the Hub has said it knows the address, the card shows "You already have an account"
// and a Sign In button; changing the email drops both and brings Continue back.
const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export default class extends Controller {
  static targets = ["input", "continue", "found", "signIn"]

  connect() {
    this.foundEmail = this.hasFoundTarget ? this.normalized() : null
    this.check()
  }

  check() {
    const known = this.foundEmail !== null && this.normalized() === this.foundEmail

    if (this.hasFoundTarget) this.foundTarget.hidden = !known
    if (this.hasSignInTarget) this.signInTarget.hidden = !known
    this.continueTarget.hidden = known
    this.continueTarget.disabled = !this.valid()
  }

  valid() {
    const input = this.inputTarget
    return EMAIL_PATTERN.test(input.value.trim()) && input.checkValidity()
  }

  normalized() {
    return this.inputTarget.value.trim().toLowerCase()
  }
}
